import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import styles from "./DirectorView.module.css";
import Footer from "../../../Components/LandingPage/Footer/Footer";
import Layout from "../../../Components/Layout";
import { getCompanyMiscData } from "../../../Services/APIrequests";
import defaultIMG from "../../../Assets/defaultimg.png";

const DirectorViewPage = () => {
  const [directorData, setDirectorData] = useState({});
  const [loading, setLoading] = useState(true);
  const { cin, din } = useParams();
  const navigate = useNavigate();


  const handleCompanyClick = (id, type = "CIN") => {
    navigate(`/kohere/Companydetails/${id}`, { state: { idType: type } });
  };


  // Fetch director details from API only
  useEffect(() => {
    const fetchDirectorDetails = async () => {
      try {
        setLoading(true);
        const response = await getCompanyMiscData(cin, din);
        console.log("API Response:", response);

        if (response?.data) {
          setDirectorData({
            ...response.data.director, // director main info
            miscData: response.data.miscData || [],
            llpMiscData: response.data.llpMiscData || [],
          });
        } else {
          setDirectorData({});
        }
      } catch (error) {
        console.error("Error fetching director details:", error);
        setDirectorData({});
      } finally {
        setLoading(false);
      }
    };

    if (cin && din) fetchDirectorDetails();
  }, [cin, din]);

  const companiesData = directorData.miscData || [];
  const llpData = directorData.llpMiscData || [];

  const handleBackClick = () => navigate(-1);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <RotatingLines
          height="80"
          width="80"
          color="#4fa94d"
          ariaLabel="loading-indicator"
          visible={true}
        />
      </div>
    );
  }

  return (
    <Layout Active={"Dashboard"}>
      <div className={styles.directorviewpage_container}>
        {/* Header */}
        <h3 className={styles.directorviewpage_header}>
          {(directorData.Designation || "Director").toUpperCase()} OVERVIEW
        </h3>

        {/* Back Button */}
        <button className={styles.backButton} onClick={handleBackClick}>
          Back
        </button>

        {/* Top Section */}
        <div className={styles.directorviewpage_top_section}>
          <div className={styles.directorviewpage_profile}>
            <img
              src={directorData.directorPicUrl || "https://via.placeholder.com/100"}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = defaultIMG;
              }}
              alt="Director"
              className={styles.directorviewpage_profile_img}
            />
            <h2 className={styles.directorviewpage_profile_name}>
              {directorData.Director_Name || "-"}
            </h2>
          </div>

          <div className={styles.directorviewpage_info}>
            <div className={styles.directorviewpage_info1}>
              <InfoItem label="Designation" value={directorData.Designation} />
              <InfoItem label="DIN / PAN" value={directorData.DIN} />
              <InfoItem
                label="Original Appointment Date"
                value={formatDate(directorData.originalAppointmentDate)}
              />
              <InfoItem
                label="Date of Cessation"
                value={formatDate(directorData.CessationDate)}
              />
              <InfoItem label="Whether DSC Registered" value={directorData.kycStatus} />
            </div>

            <div className={styles.directorviewpage_address_container}>
              <InfoItem label="Date of Birth" value={formatDate(directorData.dateOfBirth)} />
              <InfoItem label="Gender" value={directorData.gender} />
              <InfoItem label="Father's Name" value={directorData.fatherName} />
              <InfoItem label="Email of the Director" value={directorData.email} />
            </div>

            <div className={styles.directorviewpage_address}>
              <span>Present Residential Address :</span>
              <p>{directorData.address || "-"}</p>
            </div>
          </div>
        </div>


        {/* Associated Companies */}
        <DataTable
          title="List of Associated Companies:"
          data={companiesData}
          idField="CIN"
          onRowClick={handleCompanyClick}
        />

        {/* Associated LLPs */}
        <DataTable
          title="List of Associated LLPs:"
          data={llpData}
          idField="LLPIN"
          onRowClick={(id) => handleCompanyClick(id, "LLPIN")}
        />

      </div>
      <Footer />
    </Layout>
  );
};

/* Info Item Component */
const InfoItem = ({ label, value }) => (
  <div className={styles.directorviewpage_info_item}>
    <span>{label}</span>
    <h3>{value || "-"}</h3>
  </div>
);

/* Date Formatter */
const formatDate = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

/* DataTable Component */
/* DataTable Component */
const DataTable = ({ title, data, idField, onRowClick }) => (
  <div className={styles.Director_viewpage_table}>
    <h4 className={styles.Director_viewpage_heading}>{title}</h4>
    <div className={styles.table_subcontainer}>
      <table className={styles.commantable}>
        <thead className={styles.table_header}>
          <tr className={styles.tableHeaderRow}>
            <th>Sr. No</th>
            <th>{idField}</th>
            <th>{idField === "CIN" ? "Company Name" : "LLP Name"}</th>
            <th>Designation</th>
            <th>Original Date of Appointment</th>
            <th>Date of Appointment at Current Designation</th>
            <th>Date of Cessation (if applicable)</th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={`${item[idField]}-${index}`}
                className={styles.tableRow}
                onClick={() => onRowClick && onRowClick(item[idField], idField)}
                style={{ cursor: "pointer" }} // 👈 show it's clickable
              >
                <td className={styles.tableCell}>{index + 1}</td>
                <td className={styles.tableCell}>{item?.CIN || '-'}</td>
                <td
                  className={styles.tableCell}
                  style={{ color: "blue", textDecoration: "underline" }}
                >
                  {item.CompanyName || item.LLPName || "NA"}
                </td>
                <td className={styles.tableCell}>{item.PresentDesignation || "-"}</td>
                <td className={styles.tableCell}>{formatDate(item.originalAppointmentDate)}</td>
                <td className={styles.tableCell}>{formatDate(item.PDAD)}</td>
                <td className={styles.tableCell}>{formatDate(item.CessationDate)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className={styles.noData}>
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);


export default DirectorViewPage;
